<template>
	<v-dialog 
		v-model="visible"
		persistent
		lazy
		max-width="600"
		:fullscreen="false">

		<template v-slot:activator="{ on }">
			<v-btn v-on="on" icon @click="loadData"><v-icon>mdi-target</v-icon></v-btn>
		</template>

		<v-card>
			<v-card-title class="pa-0">
				<v-toolbar dense dark color="primary" card>
					<v-toolbar-title>{{ $t('DEBUG_TITLE') }}</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-toolbar-items>
						<v-btn flat small @click="close" class="hidden-xs-only">{{ $t('GENERAL_BUTTON_CLOSE') }}</v-btn>
						<v-btn icon small @click="close" class="hidden-sm-and-up"><v-icon>mdi-close</v-icon></v-btn>
					</v-toolbar-items>
				</v-toolbar>
			</v-card-title>

			<div class="pa-3">
				<v-card-text class="pa-0 mb-2">
					{{ $t('DEBUG_INSTRUCTIONS') }}
					<a :href="mailto">{{ debugMailTo }}</a>
				</v-card-text>
				<v-layout>
					<v-spacer />
					<v-btn class="mx-0" flat small @click="copy">
						{{ $t('DEBUG_BUTTON_COPY_AND_SEND') }}
						<v-icon small right>mdi-content-copy</v-icon>
					</v-btn>
				</v-layout>
				<div class="pa-2 debug-data">{{ data }}</div>
			</div>
		</v-card>
	</v-dialog>
</template>


<script>
import { mapState } from 'vuex';
import { logger, getLogs } from '@/logging';
import { copyToClipboard } from '@/utils/helpers';

export default {
	name: "dialog-debug",
	data() { return {
		visible: false,
		data: null,
		snackbarVisible: false,
	}},
	computed: {
		...mapState(['debugMode','debugMailTo','debugMailSubject']),
		mailto() {
			return `mailto:${this.debugMailTo}?subject=${this.debugMailSubject}`;
		},
	},
	methods: {
		loadData() {
			const logs = getLogs(logger.TRACE);
			const { loading, isAppReady, auth } = this.$store.state;
			this.data = JSON.stringify({ state: { loading, isAppReady, auth }, logs });
		},
		copy() {
			const copySuccess = copyToClipboard(this.data);
			if (!copySuccess) {
				alert(this.$t('DEBUG_TEXT_COPY_FAILURE', { to: this.debugMailTo }));
			}
			else {
				alert(this.$t('DEBUG_TEXT_COPY_SUCCESS'));
				window.open(encodeURI(`mailto:${this.debugMailTo}?subject=${this.debugMailSubject}`));
				this.close();
			}
		},
		close() {
			this.visible = false;
		},
	},
}
</script>

<style lang="less" scoped>
	.debug-data {
		height: 200px;
		box-sizing: border-box;
		border: 1px solid #aaa;
		overflow: auto;
		white-space: normal;
		word-break: break-all;
	}
</style>
